import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./styles";
import MotivosRejeicaoSVG from "../../assets/navbar/Convenios_on_light_blue.svg";
import motivoRejeicao from "../../services/motivos-rejeicao";

import { Formik, Form, Field } from "formik";

import InputText from "../../components/InputText";
import Button from "../../components/Button";
import Navbar from "../../components/Navbar";

import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import firstSchema from "./validations/schemaValidation";
import history from "../../utils/history";
import Table from "./subcomponents/Table";

import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";
import PoPup from "../../components/PopUp";
import { IconButton } from "@mui/material";
import { Edit as EditIcon, Add as AddIcon } from "@mui/icons-material";
import ContraparteModal from "./subcomponents/ContraparteModal";

const style = {
  justify: "center",
};

export default function MotivoRejeicaoRegistration() {
  const formRef = useRef(null);
  const { id } = useParams();
  const [formData, setFormData] = useState();
  const [motivoRejeicaoId, setMotivoRejeicaoId] = useState(null);
  const [initialState, setInitialState] = useState({
    id: null,
    descricao: "",
    contrapartes: [],
  });
  const [editing, setEditing] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [contraparte, setContraparte] = useState(null);
  const globalContext = useContext(Context);

  async function getDataById() {
    globalContext.setIsLoading(true);
    await motivoRejeicao
      .findById(id)
      .then(async (ev) => {
        const data = ev?.data;
        if (data) {
          setInitialState({ ...data, id: data.codigo });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao buscar dados, verifique os dados e tente novamente!"
          );
        }
      })
      .finally(() => globalContext.setIsLoading(false));
  }

  useEffect(() => {
    if (id) {
      getDataById();
    }

    id !== undefined && setEditing(true);
  }, [id]);

  const editContraparte = (entry) => () => {
    setContraparte(entry);
    console.log("contraparte", entry);
  };

  const eventsColumns = [
    { id: "codigo", name: "Código", style },
    { id: "descricao", name: "Descrição" },
    {
      id: "status",
      name: "Status",
      render: (value) => (value ? "Ativo" : "Inativo"),
      style,
    },
    {
      id: "Edit",
      name: "Ações",
      custom: true,
      style,
      render: (value, id, entry) => (
        <S.ActionsWrapper>
          {globalContext.isLoading ? (
            <Skeleton baseColor="#ccc" highlightColor="#eee" height="100%" />
          ) : (
            <>
              <IconButton>
                <EditIcon onClick={editContraparte(entry)}></EditIcon>
              </IconButton>
            </>
          )}
        </S.ActionsWrapper>
      ),
    },
  ];

  const sendData = async (dataForm) => {
    if (!dataForm.descricao) {
      toast.error("Digite uma descrição.");
      return;
    }
    globalContext.setIsLoading(true);

    const dataSending = {
      codigo: dataForm?.id,
      descricao: dataForm?.descricao,
      contrapartes: dataForm?.contrapartes,
    };

    // const handleEditing = async () => {
    //   try {
    //     const response = await motivoRejeicao.sendData(
    //       dataForm?.id,
    //       dataSending
    //     );
    //     if (response && (response.status === 201 || response.status === 200)) {
    //       getDataById();
    //       toast.success("Dados atualizados com sucesso!");
    //     } else if (!response) {
    //       toast.error(
    //         "Erro ao salvar dados, verifique os dados e tente novamente!"
    //       );
    //     }
    //   } catch (err) {
    //     if (err?.response?.data?.message) {
    //       toast.error(err?.response?.data?.message);
    //     } else {
    //       toast.error(
    //         "Erro ao salvar dados, verifique os dados e tente novamente!"
    //       );
    //     }
    //   } finally {
    //     globalContext.setIsLoading(false);
    //   }
    // };

    const handleCreate = async () => {
      try {
        const response = await motivoRejeicao.sendData(dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          toast.success("Dados cadastrados com sucesso!");
          history.goBack();
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    // if (id) {
    //   handleEditing();
    // } else {
    //   handleCreate();
    // }
    handleCreate();
  };

  const handleSubmit = () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };

  useEffect(() => {
    Object.keys(formRef.current.values).length >= 1
      ? setFormData(true)
      : setFormData(false);
  }, [formRef, formData]);

  const salvarContraparte = (formData, setFieldValue) => (data) => {
    const contrapartes = formData.contrapartes;
    if (data.codigo) {
      const editada = contrapartes.find((it) => it.codigo === data.codigo);
      editada.codigo = data.codigo;
      editada.descricao = data.descricao;
      editada.status = data.status;
      setFieldValue("contrapartes", contrapartes);
    } else {
      setFieldValue("contrapartes", [...contrapartes, data]);
    }
    setContraparte(null);
  };

  return (
    <>
      <Navbar className="navbar" />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={MotivosRejeicaoSVG} />
            <div>
              <S.Title>Motivos de Rejeição</S.Title>
              <S.Description>
                Cadastro geral de motivos de rejeição para o Front de Crédito
              </S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialState}
            enableReinitialize={true}
            validationSchema={firstSchema}
            onSubmit={(values) => handleSubmit}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <S.InputBox>
                  <Field
                    name="id"
                    id="id"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          width="50%"
                          label="Código:"
                          currency="false"
                          disabled
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>
                <S.InputBox>
                  <Field
                    name="descricao"
                    id="descricao"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          label="Descrição*:"
                          currency="false"
                          error={errors.descricao && touched.descricao}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                  <p>{errors.descricao}</p>
                </S.InputBox>
                <S.TableContainer>
                  <Table
                    maxHeight="300px"
                    loadingRows={3}
                    noDataMessage="Sem contra-partes"
                    columns={eventsColumns}
                    loading={globalContext.isLoading}
                    entries={values.contrapartes}
                  />
                  <S.AddContainer>
                    <IconButton onClick={() => setContraparte({})}>
                      <AddIcon></AddIcon>
                    </IconButton>
                  </S.AddContainer>
                </S.TableContainer>
                <ContraparteModal
                  open={!!contraparte}
                  contraparte={contraparte}
                  onClose={() => setContraparte(null)}
                  onSave={salvarContraparte(values, setFieldValue)}
                ></ContraparteModal>
              </Form>
            )}
          </Formik>
          <S.ButtonContainer>
            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            {/* {id && initialState.status === true ? (
              <Button
                button="primary"
                className="inativar"
                onClick={() => {
                  setPopupOpen(true);
                  setUserSelected({
                    id: initialState.id,
                    cpf: initialState.cpfCnpj,
                  });
                }}
              >
                Inativar
              </Button>
            ) : (
              <></>
            )} */}
            <Button button="primary" onClick={() => handleSubmit()}>
              {id && initialState.status === false
                ? "Ativar cadastro"
                : "Salvar cadastro"}
            </Button>
          </S.ButtonContainer>
        </S.Content>
      </S.Wrapper>

      {/* {popupOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupOpen}
          updateList={getDataById}
          userSelected={userSelected}
          endPoint="/api/motivos-rejeicao/"
          useMask="##.###.###/####-##"
          inativar={true}
          showCpfCnpj={true}
          textExclude={"Você deseja realmente inativar este motivo?"}
          messageFailed={"Error ao inativar o motivo com o CNPJ"}
          messageSuccess={"Sucesso ao inativar o motivo"}
        />
      )} */}
    </>
  );
}
